<template>
  <div>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex lg12>
          <v-card>
            <template>
              <v-toolbar card color="white">
                <v-toolbar-title class="indigo--text"
                  >Información de Reportería</v-toolbar-title
                >
              </v-toolbar>
              <grid-reporteria
                :key="indexGridReporteria"
                :itemsReporteria="itemsReporteria"
                :rowsTable="rowsTable"
              ></grid-reporteria>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import GridReporteria from "@/modules/configuration/reporteria/views/GridReporteria.vue";

export default {
  name: "reporteria-info",

  components: {
    GridReporteria,
  },

  props: {
    tabSelected: "",
  },

  data() {
    return {
      text: "En construccion",
      rowsTable: [20],
      itemsReporteria: [],
      indexGridReporteria: 0,
    };
  },

  mounted() {
    this.usuarioLogged = this.$store.getters.userLogged;
  },
  created() {},

  methods: {},
};
</script>
